import React from 'react';
import styles from '../styles/TodoCompletionModal.module.css';

/**
 * TodoCompletionModal - Celebration modal when all todos are completed
 *
 * Props:
 * - isOpen: boolean (required) - whether modal is visible
 * - onClose: function (required) - callback when user dismisses modal
 * - onSetNewGoal: function (optional) - callback when user clicks "Set New Goal"
 */
function TodoCompletionModal({ isOpen, onClose, onSetNewGoal }) {
  if (!isOpen) return null;

  const handleSetNewGoal = () => {
    if (onSetNewGoal) {
      onSetNewGoal();
    } else {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalContent}>
          <div className={styles.modalIcon}>
            <svg viewBox="0 0 1024 1024" className={styles.icon} version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M927.165022 235.879629c-3.352201-17.861679-17.085574-47.83797-71.465148-47.83797h-12.323484c-0.485322-4.473355-0.758699-9.128962-1.793847-13.12109-7.527605-29.06708-29.670149-45.730814-60.757355-45.730814H232.721967c-31.087206 0-53.22975 16.664758-60.757355 45.730814-1.03822 4.008511-1.315693 8.682548-1.801014 13.178428-54.220871 1.053578-68.480522 32.244197-72.020094 51.065257-18.483178 98.677972 174.753676 324.021822 334.206409 393.781176v112.843426h-70.392116c-21.665413 0-39.228118 17.562705-39.228119 39.228118v109.620235H690.8185V785.016974c0-21.665413-17.562705-39.228118-39.228118-39.228118h-70.392116V627.944774c153.143552-73.008143 364.509319-293.092294 345.966756-392.065145z m-38.557474 7.230679c8.666165 46.260163-72.333403 156.069816-172.334235 244.716783 63.688739-85.712512 114.859456-188.020158 125.760763-260.557313h13.666821c29.937383 0 32.101877 11.501304 32.906651 15.84053z m-751.906571 3.275409c1.076103-5.68154 3.684963-18.796487 34.802887-19.180444 11.489017 76.582527 67.800662 186.606172 136.417361 274.961332-99.576943-88.66335-180.725999-204.985938-171.220248-255.780888z m514.889405 558.245828v50.778569H361.956773v-50.778569c0-10.832707 8.781864-19.614571 19.614571-19.614571h90.006687V599.842194l-10.094485-5.611916C338.837442 526.135761 189.433119 263.921801 209.947686 184.756011c2.604764-10.08527 7.316685-16.339162 22.774281-16.339162h548.103221c15.457597 0 20.169517 6.253892 22.793735 16.339162 20.495113 79.175004-128.90921 341.379749-251.555314 409.473243l-10.094486 5.611916v185.175804H631.975811c10.833731 0 19.614571 8.781864 19.614571 19.614571z" fill="#f0c800"></path>
                <path d="M589.625866 801.470811H413.098821c-10.832707 0-19.614571 8.780841-19.614571 19.614571 0 10.831683 8.780841 19.614571 19.614571 19.614572h176.527045c10.832707 0 19.614571-8.781864 19.614571-19.614572 0-10.833731-8.780841-19.614571-19.614571-19.614571zM563.102117 456.480842c10.189707 13.514262 19.581807 28.130225 28.007359 43.772122 15.625514-11.55045 30.702225-24.665397 44.972115-39.296719-10.180492-15.2477-21.215928-29.389604-32.931224-42.367351-12.618363 14.094805-26.056858 26.743885-40.04825 37.891948zM764.867935 199.921801l-57.076488 4.16107c-11.433727 80.91049-44.340378 149.756539-87.709088 200.365143 11.929288 12.89174 23.195098 26.957877 33.624394 42.139024 56.174444-60.047803 98.898107-145.061001 111.718175-246.316092-0.185323-0.12389-0.372694-0.226279-0.556993-0.349145z" fill="#ffe7a3"></path>
              </g>
            </svg>
          </div>
          <h2 className={styles.modalTitle}>Mission Complete!</h2>
          <p className={styles.modalText}>
            Congratulations! You've completed all the tasks in your action plan.
            Ready to set your next financial goal?
          </p>
          <div className={styles.modalActions}>
            <button
              className={styles.modalButton}
              onClick={handleSetNewGoal}
            >
              Set New Goal
            </button>
            <button
              className={styles.modalButtonSecondary}
              onClick={onClose}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodoCompletionModal;
